/**
 * @generated SignedSource<<e2045cb4c83675e7e407c2efe51efbe1>>
 * @relayHash f5377fb7a336ea197d2d8df561c3c35e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba569705dcebdc323e95a461524d3052a4257acdc1042d3187378b46031e68ee

import type { ConcreteRequest } from 'relay-runtime';
export type ContentTypesHeaderQuery$variables = {
  contentId?: string | null;
  useObjectHeader: boolean;
};
export type ContentTypesHeaderQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly draftVersion?: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly id: string | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
      readonly version?: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type ContentTypesHeaderQuery = {
  response: ContentTypesHeaderQuery$data;
  variables: ContentTypesHeaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "useObjectHeader"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": [
      "archived",
      "current",
      "draft"
    ]
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "ScalarField",
  "name": "subType"
},
v9 = {
  "kind": "ScalarField",
  "name": "status"
},
v10 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v11 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v12 = {
  "kind": "ScalarField",
  "name": "number"
},
v13 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v14 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v15 = {
  "kind": "ScalarField",
  "name": "when"
},
v16 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "kind": "LinkedField",
    "name": "by",
    "plural": false,
    "selections": [
      (v14/*: any*/)
    ]
  },
  (v15/*: any*/)
],
v17 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "kind": "LinkedField",
    "name": "by",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      (v14/*: any*/)
    ]
  },
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentTypesHeaderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "condition": "useObjectHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": (v16/*: any*/)
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "draftVersion",
                    "plural": false,
                    "selections": (v16/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentTypesHeaderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "condition": "useObjectHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": (v17/*: any*/)
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "draftVersion",
                    "plural": false,
                    "selections": (v17/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f5377fb7a336ea197d2d8df561c3c35e",
    "id": "ba569705dcebdc323e95a461524d3052a4257acdc1042d3187378b46031e68ee",
    "metadata": {},
    "name": "ContentTypesHeaderQuery",
    "operationKind": "query",
    "text": "query ContentTypesHeaderQuery($contentId:ID,$useObjectHeader:Boolean!){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}\n      draftVersion@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}}}"
  }
};
})();

(node as any).hash = "2abb5d91a30df68c545d69974a9ee651";

export default node;
